import Lenis from '@studio-freight/lenis';
export default Object.freeze({
    default_product: {
        thumbnails: '/controllers/client/img/unknown.png',
        url: '/',
    },
    heading: {
        img: '/controllers/client/img/ip.png',
    },
    faqs: 'https://allinclicks.com/2026/01/04/linkbio-faq/',
});
export function smoothScrolling() {
    const lenis = new Lenis();
    function ref(time) {
        lenis.raf(time);
        requestAnimationFrame(ref);
    }
    requestAnimationFrame(ref);
}
